import createSagaMiddleware from 'redux-saga'
import thunkMiddleware from 'redux-thunk'
import { createBrowserHistory } from 'history'

import {
  createStore,
  applyMiddleware,
  combineReducers,
  compose,
} from 'redux'
import { connectRouter } from 'connected-react-router'


// Modules
import auth from './modules/auth'
import content from './modules/content'
import hacker from './modules/hacker'
import leaderboard from './modules/leaderboard'
import lrs from './modules/lrs'
import plan from './modules/plan'
import quiz from './modules/quiz'
import proxy from './modules/proxy'
import register from './modules/register'
import repl from './modules/repl'
import sso from './modules/sso'
import team from './modules/team'
import users from './modules/users'
import reports from './modules/reports'

export const history = createBrowserHistory()

const configureStore = (initialState = {} /* , history */) => {
  const sagaMiddleware = createSagaMiddleware()
  const middlewares = [
    sagaMiddleware,
    thunkMiddleware,
    // routerMiddleware(history),
  ]
  const enhancers = [
    applyMiddleware(...middlewares),
  ]

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers = (
    process.env.NODE_ENV !== 'production'
    && typeof window === 'object'
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) ? (
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ) : (
      compose
    )
  /* eslint-enable */

  const createGlobalReducer = (h) => combineReducers({
    auth,
    content,
    hacker,
    leaderboard,
    plan,
    quiz,
    proxy,
    register,
    repl,
    reports,
    sso,
    team,
    lrs,
    users,
    router: connectRouter(h),
  })

  const store = createStore(
    createGlobalReducer(history),
    initialState,
    composeEnhancers(...enhancers),
  )

  return store
}

const initialState = {}
// export const history = createBrowserHistory()

export default configureStore(initialState, history)
